import { renderDate } from '../utility/addressTabGridHelper';

export const SOP_GRID_COLUMNS = [
  {
    field: 'SOPID',
    headerName: 'Title',
    width: 200,
    valueGetter: (params) => params.row.SOP?.SOPID,
  },
  {
    field: 'DispatcherMessage',
    headerName: 'Dispatcher Message',
    width: 200,
    valueGetter: (params) => params.row.SOP?.DispatcherMessage,
  },
  {
    field: 'AlertMessage',
    headerName: 'Alert Message',
    width: 200,
    valueGetter: (params) => params.row.SOP?.AlertMessage,
  },
  {
    field: 'IsPagingMessageUsed',
    headerName: 'Is Paging Used',
    width: 160,
    type: 'boolean',
    valueGetter: (params) => params.row.SOP?.IsPagingMessageUsed,
  },
  {
    field: 'ShowPopupNotification',
    headerName: 'Popup Notification',
    width: 170,
    type: 'boolean',
    valueGetter: (params) => params.row.SOP?.ShowPopupNotification,
  },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 150 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 150 },
];
